/**************************************************
 * Nombre:       Home_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloApartados from "./SubComponentes/TituloApartados";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {TESTIMONIOS} from "../../../Constantes";
import Tarjeta_Testimonio from "../../Tarjetas/Tarjeta_Testimonio";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../../Utilidades/useIrRuta";

const Home_Testimonios = () => {
    const {sCell, masSM} = useResponsive()
    const {Aviso, abrirAviso} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >



                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <TituloApartados titulo={'Que Dicen'} inicio={'TESTIMONIOS'} negrita={'Nuestros Usuarios'}
                                     postitulo={''}
                                     frase={'Mas de 10 usuarios y experiencias'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: 1,
                            arrows: true,
                            pagination: true,
                            width: '100%',
                            drag: 'false',
                            interval: 8000,
                            noDrag: true,
                            type: 'loop',
                            gap: 20,
                            padding: !masSM ? 20 : 300


                        }}
                    >

                        {TESTIMONIOS.map((it, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Tarjeta_Testimonio item={it}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>

                </Grid>



        </Grid>
    )

}
export default Home_Testimonios

const pasos = [1, 2, 3]